var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMovie(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x35_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#415562"
    },
    d: "M511.455,140.243v289.232c0,2.743-2.315,4.886-5.058,4.886H7.917 c-2.743,0-5.058-2.143-5.058-4.886V140.243H511.455z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFB"
    },
    points: "99.676,106.815 72.847,162.205 148.261,162.205 175.091,106.815 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFB"
    },
    points: "40.063,106.811 33.89,119.67 33.89,119.755 28.147,131.586 23.947,140.243 23.175,141.701 18.289,151.902 13.317,162.189 13.317,162.274 2.43,162.274 2.43,106.811 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFB"
    },
    points: "234.673,106.815 207.844,162.205 283.258,162.205 310.088,106.815 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFB"
    },
    points: "477.837,162.205 511.387,162.205 511.387,106.815 504.667,106.815 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFB"
    },
    points: "369.67,106.815 342.841,162.205 418.255,162.205 445.084,106.815 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#415562"
    },
    points: "40.094,106.815 13.265,162.205 72.847,162.205 99.676,106.815 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#415562"
    },
    points: "175.091,106.815 148.261,162.205 207.844,162.205 234.673,106.815 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#415562"
    },
    points: "310.088,106.815 283.258,162.205 342.841,162.205 369.67,106.815 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#415562"
    },
    points: "445.084,106.815 418.255,162.205 477.837,162.205 504.667,106.815 "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6F5F5"
    },
    d: "M65.522,202.564c-0.514-1.2-1.371-2.229-2.4-3.258c-1.115-0.857-2.401-1.628-4.029-2.143 c-1.543-0.515-3.429-0.771-5.315-0.771H38.863v32.06h7.458v-12.087h7.458c1.886,0,3.772-0.258,5.315-0.857 c1.629-0.428,2.915-1.2,4.029-2.057c1.029-0.943,1.886-2.057,2.4-3.258c0.686-1.2,0.943-2.486,0.943-3.857 C66.465,205.051,66.208,203.765,65.522,202.564z M57.464,209.593c-0.943,0.772-2.314,1.201-4.115,1.201H46.32v-8.83h7.029 c1.8,0,3.172,0.428,4.115,1.199c0.943,0.858,1.457,1.887,1.457,3.173C58.922,207.708,58.407,208.737,57.464,209.593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6F5F5"
    },
    d: "M93.297,214.566c0.858-0.257,1.715-0.601,2.657-1.114c0.772-0.514,1.543-1.029,2.143-1.801 c0.686-0.686,1.2-1.542,1.543-2.399c0.429-0.857,0.6-1.973,0.6-3.086c0-1.372-0.257-2.572-0.857-3.772 c-0.514-1.2-1.371-2.143-2.4-3.086c-1.114-0.857-2.4-1.628-3.943-2.143c-1.543-0.515-3.343-0.771-5.229-0.771H72.723v32.06 h7.458v-12.858h5.401l7.544,12.858h8.658L93.297,214.566z M91.239,209.251c-0.943,0.771-2.315,1.2-3.943,1.2h-7.115v-8.486 h7.115c1.628,0,3,0.428,3.943,1.113c1.029,0.858,1.543,1.887,1.543,3.087C92.782,207.45,92.268,208.48,91.239,209.251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6F5F5"
    },
    d: "M135.044,208.308c-0.085-1.2-0.257-2.4-0.514-3.429c-0.171-1.029-0.6-1.971-1.2-2.914 c-0.429-0.772-1.2-1.629-2.143-2.486c-1.286-1.029-2.829-1.886-4.458-2.486c-1.715-0.6-3.6-0.857-5.829-0.857 c-2.229,0-4.2,0.257-5.829,0.857c-1.715,0.601-3.172,1.458-4.458,2.486c-0.943,0.857-1.715,1.714-2.229,2.486 c-0.514,0.943-0.943,1.886-1.2,2.914c-0.171,1.029-0.343,2.229-0.343,3.429c-0.086,1.199-0.086,2.572-0.086,4.115 s0,2.914,0.086,4.115c0,1.286,0.172,2.401,0.343,3.343c0.257,1.029,0.686,2.057,1.2,2.914c0.514,0.858,1.286,1.714,2.229,2.486 c1.286,1.029,2.743,1.971,4.458,2.486c1.629,0.6,3.6,0.942,5.829,0.942c2.229,0,4.115-0.342,5.829-0.942 c1.629-0.515,3.172-1.458,4.458-2.486c0.943-0.772,1.714-1.628,2.143-2.486c0.6-0.857,1.029-1.886,1.2-2.914 c0.257-0.943,0.429-2.057,0.514-3.343c0-1.2,0.086-2.572,0.086-4.115S135.044,209.507,135.044,208.308z M127.5,216.194 c-0.085,1.03-0.171,1.8-0.343,2.486c-0.172,0.686-0.343,1.114-0.6,1.542c-0.257,0.429-0.428,0.772-0.857,1.116 c-0.6,0.514-1.2,0.942-2.057,1.285c-0.772,0.343-1.629,0.515-2.743,0.515c-1.029,0-1.972-0.172-2.829-0.515 c-0.771-0.343-1.371-0.771-2.057-1.285c-0.343-0.343-0.686-0.687-0.857-1.116c-0.172-0.428-0.429-0.856-0.6-1.542 c-0.086-0.687-0.257-1.457-0.257-2.486c-0.086-0.943-0.086-2.229-0.086-3.771s0-2.829,0.086-3.857 c0-0.944,0.172-1.801,0.257-2.486c0.171-0.601,0.429-1.2,0.6-1.628c0.171-0.343,0.514-0.686,0.857-1.03 c0.686-0.514,1.286-0.943,2.057-1.285c0.857-0.343,1.8-0.429,2.829-0.429c1.115,0,1.972,0.086,2.743,0.429 c0.857,0.342,1.457,0.771,2.057,1.285c0.429,0.343,0.6,0.687,0.857,1.03c0.257,0.428,0.428,1.028,0.6,1.628 c0.172,0.685,0.257,1.542,0.343,2.486c0,1.028,0.086,2.315,0.086,3.857S127.5,215.251,127.5,216.194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6F5F5"
    },
    d: "M170.277,205.822c-0.086-0.943-0.429-1.8-0.686-2.572c-0.343-0.771-0.857-1.542-1.372-2.143 c-1.371-1.628-3-2.828-4.886-3.514c-1.886-0.858-4.115-1.2-6.773-1.2h-13.801v32.06h13.801c2.657,0,4.886-0.428,6.773-1.114 c1.886-0.857,3.514-1.971,4.886-3.6c0.515-0.686,1.029-1.459,1.372-2.143c0.257-0.858,0.6-1.629,0.686-2.572 c0.171-0.944,0.257-1.886,0.343-3.001v-7.285C170.534,207.708,170.448,206.679,170.277,205.822z M163.076,215.68 c-0.086,0.943-0.172,1.714-0.257,2.314c0,0.687-0.172,1.201-0.429,1.629c-0.171,0.429-0.514,0.857-0.857,1.2 c-1.286,1.286-3.086,1.972-5.572,1.972h-5.743v-20.83h5.743c2.486,0,4.286,0.685,5.572,1.971 c0.343,0.429,0.686,0.771,0.857,1.199c0.257,0.515,0.429,1.03,0.429,1.715c0.085,0.6,0.171,1.372,0.257,2.315V215.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6F5F5"
    },
    d: "M198.479,196.393v20.831c0,1.886-0.514,3.342-1.715,4.372c-1.286,0.942-2.829,1.542-4.972,1.542 c-1.972,0-3.6-0.601-4.801-1.542c-1.2-1.03-1.8-2.486-1.8-4.372v-20.831h-7.458v21.088c0,1.715,0.257,3.257,1.115,4.629 c0.685,1.372,1.629,2.571,3,3.515c1.286,0.942,2.743,1.714,4.458,2.229c1.714,0.6,3.6,0.856,5.486,0.856 c2.058,0,3.858-0.256,5.572-0.856c1.715-0.515,3.172-1.287,4.458-2.229c1.285-0.944,2.314-2.143,3.086-3.515 c0.686-1.372,1.029-2.914,1.029-4.629v-21.088H198.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6F5F5"
    },
    d: "M231.568,221.852c-1.029,0.771-2.486,1.286-4.372,1.286c-1.029,0-1.971-0.172-2.829-0.515 c-0.772-0.343-1.458-0.685-1.972-1.199c-0.343-0.343-0.685-0.687-0.943-1.116c-0.257-0.428-0.343-0.942-0.514-1.628 c-0.086-0.687-0.257-1.457-0.343-2.486c-0.086-0.943-0.086-2.229-0.086-3.771s0-2.829,0.086-3.857 c0.086-0.944,0.257-1.801,0.343-2.486c0.172-0.601,0.257-1.2,0.514-1.628c0.257-0.343,0.6-0.772,0.943-1.116 c0.514-0.428,1.2-0.857,1.972-1.199c0.857-0.343,1.8-0.429,2.829-0.429c1.886,0,3.343,0.429,4.286,1.285 c1.029,0.858,1.8,1.887,2.143,3.259h7.63c-0.686-3.343-2.4-5.915-4.886-7.545c-2.486-1.714-5.658-2.571-9.172-2.571 c-2.228,0-4.2,0.257-5.829,0.857c-1.629,0.601-3.086,1.458-4.457,2.486c-1.029,0.857-1.715,1.714-2.315,2.486 c-0.428,0.943-0.857,1.886-1.114,2.914c-0.257,1.029-0.343,2.229-0.429,3.429v8.229c0.086,1.286,0.171,2.401,0.429,3.343 c0.257,1.029,0.686,2.057,1.114,2.914c0.6,0.858,1.286,1.714,2.315,2.486c1.371,1.029,2.828,1.971,4.457,2.486 c1.629,0.6,3.601,0.942,5.829,0.942c3.515,0,6.687-0.942,9.172-2.571c2.486-1.715,4.2-4.2,4.886-7.63h-7.63 C233.283,219.881,232.511,220.909,231.568,221.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6F5F5"
    },
    d: "M244.855,196.393v5.572h10.116v26.488h7.458v-26.488h10.029v-5.572H244.855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6F5F5"
    },
    d: "M278.545,196.393v32.06h7.543v-32.06H278.545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6F5F5"
    },
    d: "M321.921,208.308c0-1.2-0.172-2.4-0.343-3.429c-0.257-1.029-0.686-1.971-1.286-2.914 c-0.429-0.772-1.2-1.629-2.143-2.486c-1.286-1.029-2.829-1.886-4.458-2.486c-1.629-0.6-3.6-0.857-5.829-0.857 c-2.229,0-4.115,0.257-5.829,0.857c-1.715,0.601-3.172,1.458-4.458,2.486c-0.943,0.857-1.715,1.714-2.229,2.486 c-0.6,0.943-0.857,1.886-1.114,2.914c-0.257,1.029-0.428,2.229-0.428,3.429c-0.086,1.199-0.086,2.572-0.086,4.115 s0,2.914,0.086,4.115c0,1.286,0.172,2.401,0.428,3.343c0.257,1.029,0.514,2.057,1.114,2.914 c0.514,0.858,1.286,1.714,2.229,2.486c1.286,1.029,2.743,1.971,4.458,2.486c1.715,0.6,3.6,0.942,5.829,0.942 c2.229,0,4.2-0.342,5.829-0.942c1.629-0.515,3.172-1.458,4.458-2.486c0.943-0.772,1.714-1.628,2.143-2.486 c0.6-0.857,1.029-1.886,1.286-2.914c0.172-0.943,0.343-2.057,0.343-3.343c0.085-1.2,0.085-2.572,0.085-4.115 S322.007,209.507,321.921,208.308z M314.463,216.194c-0.086,1.03-0.172,1.8-0.343,2.486c-0.172,0.686-0.343,1.114-0.6,1.542 c-0.171,0.429-0.514,0.772-0.857,1.116c-0.514,0.514-1.2,0.942-1.971,1.285c-0.857,0.343-1.8,0.515-2.829,0.515 c-1.029,0-1.971-0.172-2.743-0.515c-0.857-0.343-1.543-0.771-2.143-1.285c-0.343-0.343-0.6-0.687-0.857-1.116 c-0.257-0.428-0.429-0.856-0.6-1.542c-0.172-0.687-0.257-1.457-0.257-2.486v-7.628c0-0.944,0.086-1.801,0.257-2.486 c0.171-0.601,0.343-1.2,0.6-1.628c0.257-0.343,0.514-0.686,0.857-1.03c0.6-0.514,1.286-0.943,2.143-1.285 c0.772-0.343,1.715-0.429,2.743-0.429c1.029,0,1.972,0.086,2.829,0.429c0.771,0.342,1.457,0.771,1.971,1.285 c0.343,0.343,0.686,0.687,0.857,1.03c0.258,0.428,0.429,1.028,0.6,1.628c0.172,0.685,0.257,1.542,0.343,2.486 c0.085,1.028,0.085,2.315,0.085,3.857S314.549,215.251,314.463,216.194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6F5F5"
    },
    d: "M351.581,196.393v19.63l-15.173-19.63h-6.687v32.06h7.458v-19.716l15.259,19.716h6.686v-32.06 H351.581z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 172.986,
    y: 250.867,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.806,
    height: 68.479
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 336.526,
    y: 250.867,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.806,
    height: 68.479
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 59.871,
    y: 331.36,
    style: {
      fill: "#FFFFFF"
    },
    width: 394.574,
    height: 4.806
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.871,
    y: 335.965,
    style: {
      fill: "#FFFFFF"
    },
    width: 394.574,
    height: 4.806
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.871,
    y: 378.815,
    style: {
      fill: "#FFFFFF"
    },
    width: 394.574,
    height: 4.806
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 59.871,
    y: 373.408,
    style: {
      fill: "#FFFFFF"
    },
    width: 394.574,
    height: 4.806
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFB"
    },
    points: "505.345,55.749 512,54.819 510.023,41.087 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFB"
    },
    points: "63.95,59.752 0,68.429 7.51,123.307 44.875,118.238 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFB"
    },
    points: "197.708,41.577 178.677,100.124 129.301,106.811 103.926,110.24 105.041,106.811 122.957,51.777 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFB"
    },
    points: "465.25,5.315 463.964,9.173 446.22,63.778 403.701,69.521 371.469,73.894 390.5,15.431 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFB"
    },
    points: "331.522,23.488 312.406,81.952 237.655,92.067 256.771,33.604 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#415562"
    },
    points: "122.957,51.777 105.041,106.811 103.926,110.24 97.583,111.097 66.98,115.212 44.863,118.213 48.549,106.811 51.035,99.268 54.635,88.21 63.979,59.749 86.096,56.749 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#415562"
    },
    points: "256.771,33.604 237.655,92.067 178.677,100.124 197.708,41.577 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#415562"
    },
    points: "390.5,15.431 371.469,73.894 312.406,81.952 331.522,23.488 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#415562"
    },
    points: "509.998,41.062 509.998,41.148 509.227,43.462 505.198,55.806 446.22,63.778 463.964,9.173 465.25,5.315 468.251,4.887 497.739,0.858 504.34,0 505.541,8.658 "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D535C"
    },
    d: "M75.007,152.798H22.641c-6.763,0-12.246-5.483-12.246-12.246V88.186 c0-10.91,13.191-16.374,20.906-8.66l52.366,52.366C91.381,139.607,85.917,152.798,75.007,152.798z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FAFAFB"
    },
    cx: 27.109,
    cy: 97.398,
    r: 5.868
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FAFAFB"
    },
    cx: 27.109,
    cy: 137.378,
    r: 5.868
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FAFAFB"
    },
    cx: 65.073,
    cy: 137.378,
    r: 5.868
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2.859,
    y: 162.274,
    style: {
      opacity: 0.2,
      fill: "#1D1E1E"
    },
    width: 508.597,
    height: 9.43
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#1D1E1E"
    },
    points: "509.998,41.062 509.998,41.148 509.227,43.462 505.198,55.806 446.22,63.778 403.615,69.607 403.701,69.521 463.964,9.173 468.251,4.887 497.739,0.858 504.34,0 505.541,8.658 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#1D1E1E"
    },
    d: "M511.386,106.815h-6.72h-59.583H369.67h-3.3L38.813,434.372h467.619 c2.741,0,4.999-2.177,4.999-4.918V171.673v-9.433v-22.012h-0.044V106.815z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#1D1E1E"
    },
    points: "512,54.819 510.023,41.087 505.345,55.75 "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovie);
export default __webpack_public_path__ + "static/media/movie.1a2ad9c5b8ece150d495a34a399c4e0b.svg";
export { ForwardRef as ReactComponent };